import { render, staticRenderFns } from "./NovosibirskModal.vue?vue&type=template&id=1221e076&"
import script from "./NovosibirskModal.vue?vue&type=script&lang=js&"
export * from "./NovosibirskModal.vue?vue&type=script&lang=js&"
import style0 from "./NovosibirskModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports